import axios from 'axios';
import BaseAPI from './base-api';
import ListItem_ from './models/ListItem';
import ResponseBase_ from './models/ResponseBase';

export type LtPars = {
  listName: string,
  sortOrder?: string,
  sortColumn?: string
};

export default class ListAPI extends BaseAPI {
  static getLtItemsSearch(pars: LtPars): Promise<ResponseBase_<ListItem_[]>> {
    const { listName, sortOrder = 'ASC', sortColumn = 'Descrip', } = pars;

    return BaseAPI.promiseWrapper<ListItem_[]>(axios({
      method: 'POST',
      url: `${window.feHost}/api/LoanApplications/InquirePickList`,
      data: JSON.stringify({ ltName: listName, sortOrder, sortColumn, }),
      headers: this.getRequestHeaders(),
    }), null);
  }
}
